import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { TextBolder12, TextRegular14 } from '../../VuexyDesign/atoms/Text';
import { TextRegular12 } from '../common/Text';
import {
  CommunityPostInfo,
  downvoteOnPost,
  reverseVote,
  upvoteOnPost,
} from '../../api/lib/api/musicKnowledgeHub';
import UpvoteDownVote from './UpvoteDownVote';
import { setBlogPostInfoData } from '../../api/redux/dispatch/musicKnowledgeHub';
import Link from '../common/Link';
import { useDispatch } from '../../api';

function PostCard({ postInfoData }: { postInfoData: CommunityPostInfo }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('musicKnowledgeHub');
  const onUpvoteHandler = async () => {
    if (postInfoData.logged_in_user_voted === 1) {
      reverseVote(postInfoData.id).then((res) => {
        if (res) {
          dispatch(setBlogPostInfoData(res));
        }
      });
    } else {
      upvoteOnPost(postInfoData.id).then((res) => {
        if (res) {
          dispatch(setBlogPostInfoData(res));
        }
      });
    }
  };

  const onDownvoteHandler = async () => {
    if (postInfoData.logged_in_user_voted === -1) {
      reverseVote(postInfoData.id).then((res) => {
        if (res) {
          dispatch(setBlogPostInfoData(res));
        }
      });
    } else {
      downvoteOnPost(postInfoData.id).then((res) => {
        if (res) {
          dispatch(setBlogPostInfoData(res));
        }
      });
    }
  };
  return (
    <PostCardWrapper>
      <div className="mb-2">
        <span
          className="badge-blog-post"
          style={{ backgroundColor: '#4F566E' }}
        >
          {postInfoData.community.name}
        </span>
      </div>
      <div>
        <span className="blog-post-title ">{postInfoData.title}</span>
      </div>
      <div style={{ marginTop: '0.5rem' }}>
        <Link href="/music-knowledge-hub">
          <TextRegular14>
            {t('musicKnowledgeHub:musicKnowledgeHub')}
          </TextRegular14>
          {'  '}
        </Link>
        / {'  '}
        <Link
          href={`/music-knowledge-hub/community/${postInfoData.community.slug}`}
        >
          <TextRegular14> {postInfoData.community.name} </TextRegular14>
        </Link>
        /{'  '}
        <TextRegular14>{postInfoData.title} </TextRegular14>
      </div>
      <div className="blog-post-description mt-2">
        <TextRegular14 style={{ color: '#232323' }}>
          {ReactHtmlParser(postInfoData.body)}
        </TextRegular14>
      </div>

      <div className="d-flex justify-content-between mt-3">
        <TextRegular12>
          {formatDistanceToNow(new Date(postInfoData.created_at * 1000))}{' '}
          {t('musicKnowledgeHub:ago')}
        </TextRegular12>
        <div className="d-flex align-items-center">
          <TextBolder12 className="usefull-post-margin">
            {t('musicKnowledgeHub:usefullPost')}
          </TextBolder12>
          <UpvoteDownVote
            voteData={postInfoData}
            type="upvote"
            className="cursor-pointer"
            onClick={onUpvoteHandler}
          />
          <UpvoteDownVote
            voteData={postInfoData}
            type="downvote"
            className=" cursor-pointer"
            onClick={onDownvoteHandler}
          />
        </div>
      </div>
    </PostCardWrapper>
  );
}

const PostCardWrapper = styled.div`
  .usefull-post-margin {
    margin-right: 1rem;
  }
  .badge-blog-post {
    color: #ffffff;
    padding: 0.4rem 1rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 12px;
  }

  .blog-post-title {
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
  }
  .blog-post-description {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
`;

export default PostCard;
